import { RegistryPayoutAccountWithdrawalStatus } from '@graphql/generated';
import { createContext } from '@shared/utils/createContext';

export interface PayoutAccountInfo {
  status: 'onboarding' | 'readyToUse' | 'pending' | 'rejected';
  statusDetails: string;
  onboardingUrl: string;
  serviceDashboardUrl: string;
  externalAccountLast4: string | null;
  balance?: PayoutAccountBalance;
  withdrawals: PayoutAccountWithdrawal[];
}

export interface PayoutAccountBalance {
  availablePending: CommerceMonetaryValue;
  available: CommerceMonetaryValue;
  received: CommerceMonetaryValue;
  withdrawn: CommerceMonetaryValue;
  withdrawnPending: CommerceMonetaryValue;
}

export interface PayoutAccountWithdrawal {
  id: string;
  status: RegistryPayoutAccountWithdrawalStatus;
  totalValue: CommerceMonetaryValue;
}

export interface CommerceMonetaryValue {
  currencyCode: string;
  valueInMinorUnits: number;
  valueInMajorUnits: number;
}
interface CreditCardSetupContext {
  setSetupCreditCard: (nextValue: string | null) => void;
  fetchingPayoutInfo: boolean;
  /** Returns 'true' when there was a successful withdrawal in current session */
  hasDoneWithdrawal: boolean;
  hasFailedWithdrawals: boolean;
  hasPendingWithdrawals: boolean;
  payoutAccountInfo: PayoutAccountInfo | null;
  maxAttemptsReached: boolean;
  initKYCOnboarding: () => void;
  initKYCOnboardingFromRefund: (returnRoute: string) => void;
  fetchPayoutInfo: () => void;
  onOpenPayoutDialog: () => void;
  initPayoutAccountLoading: boolean;
}

export const [Provider, useCreditCardSetupContext] = createContext<CreditCardSetupContext>({ name: 'CreditCardSetUpContext' });
